import * as React from 'react';

import { NewbuildingCallButton } from '../../components/NewbuildingCallButton';
import { useDynamicPhone } from '../../hooks/useDynamicPhone';

export interface INewbuildingCallButtonContainerProps {
  entityId: number;
  phone?: string | null;
  siteBlockId?: number | null;
  onClick?(): void;
}

export const NewbuildingCallButtonContainer: React.FC<INewbuildingCallButtonContainerProps> = ({
  entityId,
  phone,
  siteBlockId,
  onClick,
}) => {
  const callPhone = useDynamicPhone({ entityId, phone, siteBlockId });

  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick();
    }

    callPhone();
  }, [callPhone, onClick]);

  if (!phone && !siteBlockId) {
    return null;
  }

  return <NewbuildingCallButton onClick={handleClick} />;
};
